// GET NEW CLIENTS 
export const GET_NEW_CLIENTS = "GET_NEW_CLIENTS"
export const GET_NEW_CLIENTS_SUCCESS = "GET_NEW_CLIENTS_SUCCESS"
export const GET_NEW_CLIENTS_FAIL = "GET_NEW_CLIENTS_FAIL"
// GET SELECTED MANAGER NEW CLIENTS 
export const GET_SELECTED_NEW_CLIENTS = "GET_SELECTED_NEW_CLIENTS"
export const GET_SELECTED_NEW_CLIENTS_SUCCESS = "GET_SELECTED_NEW_CLIENTS_SUCCESS"
export const GET_SELECTED_NEW_CLIENTS_FAIL = "GET_SELECTED_NEW_CLIENTS_FAIL"

export const SHOW_LOADING = "SHOW_LOADING"
export const HIDE_LOADING = "HIDE_LOADING"